<header class="flex header">
  <h2>
    {{ business.name }} <span class="text-sm font-normal text-gray-400">({{ business.code }})</span>
  </h2>
  <p-button icon="pi pi-times" (click)="onClose()" [disabled]="isSaving()" />
</header>

@if (isSaving()) {
  <p-progressbar mode="indeterminate" [style]="{ height: '6px' }" />
}

<div class="content">
  <p-card>
    <div class="col">
      <!-- Existing lot numbers as removable chips -->
      <div class="form-box">
        <label>Lot Numbers</label>
        <div class="row-xs flex-wrap min-h-[2.5rem]">
          <p-tag *ngFor="let lot of editableLotNumbers()" [value]="lot" severity="secondary">
            <ng-template pTemplate="content">
              <span>{{ lot }}</span>
              <i class="pi pi-times ml-2" style="font-size: 0.7rem; cursor: pointer" (click)="removeLotNumber(lot)"></i>
            </ng-template>
          </p-tag>
          <span *ngIf="editableLotNumbers().length === 0" class="text-gray-400 text-sm self-center"> No lot numbers yet </span>
        </div>
      </div>

      <!-- Add new lot number -->
      <div class="row-sm-start-center">
        <input
          pInputText
          type="text"
          [ngModel]="newLotNumber()"
          (ngModelChange)="newLotNumber.set($event)"
          (keydown)="onKeydown($event)"
          placeholder="Type lot number and press Enter or +"
          class="flex-1"
        />
        <p-button icon="pi pi-plus" (click)="addLotNumber()" [disabled]="!newLotNumber().trim()" />
      </div>
    </div>
  </p-card>
</div>

<footer>
  <p-button class="w-full" label="Save" (click)="onSave()" [disabled]="isSaving()" />
  <p-button class="w-full" label="Exit" variant="outlined" (click)="onClose()" [disabled]="isSaving()" />
</footer>
